import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright © 2025-2026 Cognizant Digital Business, Evolutionary AI.
 * All Rights Reserved.
 * Issued under the Academic Public License.
 *
 * You can be released from the terms, and requirements of the Academic Public
 * License by purchasing a commercial license.
 * Purchase of a commercial license is mandatory for any use of the
 * LMX Software in commercial settings.
 */
// END COPYRIGHT
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
export const LightTooltip = styled(({ className, placement = "top", ...props }) => (_jsx(Tooltip, { ...props, placement: placement, classes: { popper: className } })))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: "rgba(0, 0, 0, 0.87)",
        boxShadow: theme.shadows[1],
        fontSize: 14,
        maxWidth: 520,
        whiteSpace: "normal",
        padding: theme.spacing(1.25, 1.5),
    },
}));
